import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0e8dc608"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "empty-continer" }
const _hoisted_2 = { class: "empty-icon" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "empty-tip" }


export default /*#__PURE__*/_defineComponent({
  __name: 'empty',
  props: {
    height: {}
  },
  setup(__props: any) {

/*
 * @author: Lew
 * @e-mail: yaol@jiguang.cn
 * @date: 2022/09/21 15:45:03
 * @description: 空数据
 */


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", {
    class: "empty",
    style: _normalizeStyle({ height: `${_ctx.height}px` })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("p", _hoisted_2, [
        _createElementVNode("img", {
          src: require('./empty.png')
        }, null, 8, _hoisted_3)
      ]),
      _createElementVNode("span", _hoisted_4, [
        _renderSlot(_ctx.$slots, "tip")
      ])
    ])
  ], 4))
}
}

})